import "./Palette.css";
import ChosenColor from "./ChosenColor";

function Palette({colors}) {
    return(
    <div className="palette">
        <ChosenColor color={colors[0]}></ChosenColor>
        <ChosenColor color={colors[1]}></ChosenColor>
        <ChosenColor color={colors[2]}></ChosenColor>
        <ChosenColor color={colors[3]}></ChosenColor>
    </div>
    );
}

export default Palette;